import { renderIcon } from "../icons";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";

type Rule = {
  label: string;
  valid: boolean;
};

export function passwordRules(password: string): Rule[] {
  return [
    { label: "At least 8 characters", valid: password.length >= 8 },
    { label: "Contains a number", valid: /\d/.test(password) },
    { label: "Contains an uppercase letter", valid: /[A-Z]/.test(password) },
  ];
}

export function PasswordRequirements({
  password,
  className = "space-y-1 text-sm",
  iconClassName = "h-4 w-4",
}: {
  password: string;
  className?: string;
  iconClassName?: string;
}) {
  const rules = passwordRules(password);
  return (
    <div className={className}>
      {rules.map((rule) => (
        <div
          key={rule.label}
          className={`flex items-center gap-2 ${
            rule.valid
              ? "text-emerald-600"
              : "text-[rgb(var(--color-muted))]"
          }`}
        >
          {renderIcon(
            rule.valid ? IoCheckmarkCircle : IoCloseCircle,
            iconClassName
          )}
          <span>{rule.label}</span>
        </div>
      ))}
    </div>
  );
}
